
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { TotemModel } from '../../../models/application/totem/totem';

@Injectable()
export class StructureTotemListProvider implements Resolve<any> {
    totem: TotemModel[];
    totemEdit: TotemModel;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.totemEdit = this.state?.currentTotemTO;

        return new Promise((resolve, reject) => {
            Promise.all([

            ]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    get(id: number): Observable<TotemModel> {
        if (!id) {
            return null;
        }
        return this.gw.get('totem/:id', { id: id });
    }

    getById(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('totem/' + id).subscribe({
                next: (res: TotemModel) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        })

    }

    get currentTotemTO(): TotemModel {
        return this.totemEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('totem/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.totem = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('totem/search', pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.totem, res.body.content) && res.body.content.length > 0) {
                        this.totem = res.body.content;
                        this.onDataChanged.next(this.totem);
                    }
                    else {
                        this.totem = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getQuantityPassword(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('totem/quantity-password').subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getNextPassword(companyId, environmentId, typePassword): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`totem/next-password/${companyId}/${environmentId}/${typePassword}`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    listNextPassword(companyId, environmentId, pageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`totem/list-next-password/${companyId}/${environmentId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    listOldPassword(companyId, pageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`totem/list-old-password/${companyId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    totemSchedule(companyId, pageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`totem/schedule/search/${companyId}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

